import { useCallback } from 'react'

import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import {
  type KyrgyzstanRestPlace,
  kyrgyzstanSearchStore,
} from 'entities/kyrgyzstan/model'
import type { RestPlaceCardItem } from 'entities/kyrgyzstan/ui/rest-places'

import { findRestPlaceByCardItem, getRestPlaceDates } from './lib'

export const useSelectRestPlace = (places: KyrgyzstanRestPlace[]) => {
  const navigate = useNavigate()

  return useCallback(
    (item: RestPlaceCardItem) => {
      const selected = findRestPlaceByCardItem(places, item)
      if (!selected) return

      kyrgyzstanSearchStore.reset()
      kyrgyzstanSearchStore.resetFilters()

      if (selected.cities.length > 0) {
        kyrgyzstanSearchStore.setCities(selected.cities)
      }

      const { startDate, endDate } = getRestPlaceDates(selected)

      kyrgyzstanSearchStore.setStartDate(startDate)
      kyrgyzstanSearchStore.setEndDate(endDate)

      navigate(RoutingPaths.kyrgyzstan.searchResult.path())
    },
    [navigate, places],
  )
}
